import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

import HomeHero from '../components/HomeHero';
import AboutRodo from '../components/AboutRodo';
import Clients from '../components/Clients';
import Team from '../components/Team';
import Contact from '../components/Contact';

const IndexPage = ({ data }) => (
  <div>
    <HomeHero heroImage={data.headerImage} />

    <section className="pure-text-centered primary-background text-white">
      <div className="container">
        <div className="row">
          <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 text-center">
            <p className="lead" style={{ padding: '0 10px' }}>
              RODO (Rozporządzenie o Ochronie Danych Osobowych) to Rozporządzenie Parlamentu Europejskiego i Rady UE z
              27 kwietnia 2016. Reguluje ono kwestie ochrony danych osobowych osób fizycznych oraz ich przepływu.
            </p>
          </div>
        </div>
      </div>
    </section>

    <AboutRodo image={data.cctvImage} />

    <Clients clientImage={data.clientImage} />

    <section className="duplicatable-content" id="offer">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <h1>
              <strong>Jakie działania powinieneś podjąć</strong>
              <br />By sprostać wymaganiom nowej regulacji?
            </h1>
          </div>
        </div>

        <div className="row">
          <ul className="col-md-12 list text-left" style={{ margin: '0' }}>
            <li>Przeprowadzić audyt umów powierzenia danych osobowych</li>
            <li>Przygotować dokumentację procesów przetwarzania danych osobowych</li>
            <li>Przygotować dokumentację procesów zabezpieczenia danych osobowych</li>
            <li>Sprawować nadzór nad wdrażaniem procedur wewnątrz swojej organizacji</li>
            <li>Przeprowadzić audyt procesów przetwarzania danych osobowych w Twojej firmie</li>
            <li>
              Wyznaczyć oraz przeszkolić pracowników odpowiedzialnych za procesy przetwarzania i zabezpieczania danych
              osobowych
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section className="primary-background side-image clearfix">
      <div className="image-container col-md-5 pull-right ">
        <Img
          resolutions={data.elegantImage.resolutions}
          imgStyle={{ objectPosition: '0 0' }}
          className="image-full-width"
          outerWrapperClassName="image-full-width"
        />
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-6 col-sm-12 content clearfix">
            <h1 className='text-white'>Przygotujemy Cię</h1>
            <p className="lead text-white">
              Śpij spokojnie powierzając nam dostosowanie Twojej organizacji do wymagań RODO.<br />
              Jedyne co musisz zrobić to:
            </p>
            <ol className="text-light">
              <li>Spotkać się z nami i wyznaczyć osoby odpowiedzialne za współpracę.</li>
              <li>Pozwolić nam na audyt dokumentów i procesów zachodzących w Twojej firmie.</li>
              <li>Zaakceptować procedury spisane przez nas na podstawie wcześniej wykonanego audytu.</li>
              <li>Wyznaczyć osobę odpowiedzialną za dane osobowe w Twojej organizacji, którą przeszkolimy.</li>
            </ol>
            <br />
            <p className="text-light">
              Po przeprowadzonym dostosowaniu będziemy zawsze pod ręką. Przejmiemy obowiązki Inspektora Ochrony Danych
              Osobowych Twojej organizacji i będziemy sprawować nadzór nad wdrożonymi przez nas procesami.
            </p>
          </div>
        </div>
      </div>
    </section>
    <Team marek={data.marekImage.resolutions} kasia={data.kasiaImage.resolutions} />
    <Contact />
  </div>
);

IndexPage.propTypes = {
  data: PropTypes.shape({}).isRequired,
};

export default IndexPage;

export const pageQuery = graphql`
  query HeaderImageQuery {
    headerImage: imageSharp(id: { regex: "/hero-image/" }) {
      resolutions(width: 1200) {
        ...GatsbyImageSharpResolutions
      }
    }
    cctvImage: imageSharp(id: { regex: "/o-co-chodzi/" }) {
      resolutions(height: 1250, width: 1800) {
        ...GatsbyImageSharpResolutions
      }
    }
    elegantImage: imageSharp(id: { regex: "/przygotujemy-cie/" }) {
      resolutions(height: 1250, width: 1150) {
        ...GatsbyImageSharpResolutions
      }
    }
    marekImage: imageSharp(id: { regex: "/marek/" }) {
      resolutions(height: 1000, width: 1000) {
        ...GatsbyImageSharpResolutions
      }
    }
    kasiaImage: imageSharp(id: { regex: "/kasia/" }) {
      resolutions(height: 1000, width: 1000) {
        ...GatsbyImageSharpResolutions
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js